const { refMatchesDtVoucherCodePattern } = require('@/lib/GiftVouchers');

/**
 * Show a gift voucher ref in a human-friendly format for reading.
 * - Remove dashes and spaces.
 * - Convert to uppercase.
 *
 * e.g. "hello world" becomes "HELLOWORLD"
 *
 * If the ref matches the pattern of a DT-generated voucher code it will get dashes added at 4 letter intervals.
 *
 * e.g. "v3fk9q249fv5kk2j" becomes "V3FK-9Q24-9FV5-KK2J"
 *
 * @param {string} ref
 */
const presentSoldGiftVoucherRefFilter = (ref) => {
    // Convert to uppercase and remove spaces.
    let formatted = (ref || '')
        .toUpperCase()
        .replace(/[\s-]/g, '');

    // If this ref matches the standard DT ref format we'll present it with dashes.
    if (refMatchesDtVoucherCodePattern(ref)) {
        formatted = formatted.match(/.{1,4}/g).join('-');
    }

    return formatted;
};

module.exports = presentSoldGiftVoucherRefFilter;
